"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/user-setup-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Fuser-setup-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSetupServiceClient = exports.CreateUsersResponse = exports.CreateUsersRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const setup_user_1 = require("./setup-user");
const protobufPackage = 'com.step.testapi.proto';
function createBaseCreateUsersRequest() {
    return { users: [] };
}
exports.CreateUsersRequest = {
    fromJSON(object) {
        const message = {
            users: globalThis.Array.isArray(object?.users)
                ? object.users.map((e) => setup_user_1.SetupUserRequest.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.users?.length) {
            obj.users = message.users.map((e) => setup_user_1.SetupUserRequest.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.CreateUsersRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateUsersRequest();
        message.users = object.users?.map((e) => setup_user_1.SetupUserRequest.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCreateUsersResponse() {
    return { users: [] };
}
exports.CreateUsersResponse = {
    fromJSON(object) {
        const message = {
            users: globalThis.Array.isArray(object?.users)
                ? object.users.map((e) => setup_user_1.SetupUserResponse.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.users?.length) {
            obj.users = message.users.map((e) => setup_user_1.SetupUserResponse.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.CreateUsersResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateUsersResponse();
        message.users = object.users?.map((e) => setup_user_1.SetupUserResponse.fromPartial(e)) || [];
        return message;
    },
};
/**
 * Test User Setup Service.
 */
class UserSetupServiceClient {
    rpc;
    name = 'com.step.testapi.proto.UserSetupService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'CreateUsers',
            requestType: exports.CreateUsersRequest,
            responseType: exports.CreateUsersResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Creates random test users.
     */
    createUsers(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.UserSetupServiceClient = UserSetupServiceClient;
//# sourceMappingURL=user-setup-service.js.map